import modelResultFactory from "./ModelResult";
import ResultTable from "~/ui/components/ResultTable/ResultTable";

export default modelResultFactory({ ResultComponent: ResultTable });